// src/components/ui/ExhibitTypeSwitch.js
import React from 'react';
import * as Switch from '@radix-ui/react-switch';

/**
 * Custom 3D Exhibit Type Switch Component
 * Toggles between letters (ABC) and numbers (123)
 * 
 * @param {boolean} checked - If true, shows numbers (123); if false, shows letters (ABC)
 * @param {function} onCheckedChange - Callback when switch is toggled
 */
const ExhibitTypeSwitch = ({ checked, onCheckedChange }) => {
  return (
    <Switch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="relative"
      style={{
        width: '96px',
        height: '28px',
        backgroundColor: '#E1E5EA', // app-gray-300
        borderRadius: '14px', // pill shape (half of height)
        border: '1px solid #0C141D', // app-gray-900
        boxShadow: '0 -4px 0 0 #0C141D', // drop shadow above, no blur
        position: 'relative',
        cursor: 'pointer',
        flexShrink: 0
      }}
    >
      {/* Background text labels */}
      <div className="absolute inset-0 flex pointer-events-none">
        {/* ABC label - left half */}
        <div className="flex-1 flex items-center justify-center">
          <span className="text-app-sm font-bold text-app-gray-900">
            ABC
          </span>
        </div>
        
        {/* 123 label - right half */}
        <div className="flex-1 flex items-center justify-center">
          <span className="text-app-sm font-bold text-app-gray-900">
            123
          </span>
        </div>
      </div>

      {/* Slider thumb */}
      <Switch.Thumb
        className="flex items-center justify-center transition-transform duration-app-normal ease-out bg-app-gray-200"
        style={{
          width: '54px',
          height: '28px',
          borderRadius: '14px', // pill shape
          border: '1px solid #0C141D', // app-gray-900
          boxShadow: '0 4px 0 0 #0C141D', // drop shadow below, no blur
          transform: checked ? 'translateX(41px) translateY(-5px)' : 'translateX(-1px) translateY(-5px)',
          willChange: 'transform'
        }}
      >
        <span className="text-app-xs text-app-gray-900 font-normal">
          Label
        </span>
      </Switch.Thumb>
    </Switch.Root>
  );
};

export default ExhibitTypeSwitch;